import React from 'react';

import './styles.css';

export default function StudentClassCardInfo(props) {
    return(
        <span className={'student-section-card-info' + (props.soon ? ' soon':'')}>
            <p className='info-tittle'>{props.tittle}</p>
            { props.data !== undefined ? <p className='info-data'>{props.data}</p> :[] }
        </span>
    )
}